import {
    LIST_USER_CLIENT_REQUEST,
    LIST_USER_CLIENT_SUCCESS,
    LIST_USER_CLIENT_FAIL,
    CREATE_USER_CLIENT_REQUEST,
    CREATE_USER_CLIENT_SUCCESS,
    CREATE_USER_CLIENT_FAIL,
    DETAIL_USER_CLIENT_REQUEST,
    DETAIL_USER_CLIENT_SUCCESS,
    DETAIL_USER_CLIENT_FAIL,
    UPDATE_USER_CLIENT_REQUEST,
    UPDATE_USER_CLIENT_SUCCESS,
    UPDATE_USER_CLIENT_FAIL,
    DELETE_USER_CLIENT_REQUEST,
    DELETE_USER_CLIENT_SUCCESS,
    DELETE_USER_CLIENT_FAIL,
    USER_CLIENT_RESET
} from '../../constants/users'

const initialState = {
    loading: false,
    loadingDetail: false,
    loadingUpdate: false,
    usersClient: [],
    userClient: {},
    error: null,
    status: '',
    message: '',
    pageable: {}
}

const usersClientReducer = (state = initialState, action) => {
    switch (action.type) {
        // Client
        case LIST_USER_CLIENT_REQUEST:
            return { ...state, loading: true }
        case LIST_USER_CLIENT_SUCCESS:
            return { ...state, loading: false, usersClient: action.payload, pageable: action.pageable }
        case LIST_USER_CLIENT_FAIL:
            return { ...state, loading: false, error: action.payload, usersClient: [] }
        case USER_CLIENT_RESET:
            return { usersClient: [] }
        case CREATE_USER_CLIENT_REQUEST:
            return { ...state, loading: true }
        case CREATE_USER_CLIENT_SUCCESS:
            const newUserClient = action.payload
            return { ...state, loading: false, success: true, usersClient: [...state.usersClient, newUserClient] }
        case CREATE_USER_CLIENT_FAIL:
            return { ...state, loading: false, error: action.payload }
        case DETAIL_USER_CLIENT_REQUEST:
            return { ...state, loadingDetail: true }
        case DETAIL_USER_CLIENT_SUCCESS:
            return { ...state, loadingDetail: false, userClient: action.payload }
        case DETAIL_USER_CLIENT_FAIL:
            return { ...state, loadingDetail: false, error: action.payload }
        case UPDATE_USER_CLIENT_REQUEST:
            return { ...state, loadingUpdate: true }
        case UPDATE_USER_CLIENT_SUCCESS:
            const usersClientData = [...state?.usersClient]
            const indexClient = usersClientData.findIndex(user => user.id === action.payload.id)
            usersClientData[indexClient] = action.payload

            return { ...state, loadingUpdate: false, success: true, usersClient: usersClientData }
        case UPDATE_USER_CLIENT_FAIL:
            return { ...state, loadingUpdate: false, error: action.payload }
        case DELETE_USER_CLIENT_REQUEST:
            return { ...state, loading: true }
        case DELETE_USER_CLIENT_SUCCESS:
            return { ...state, loading: false, success: true, usersClient: state.usersClient?.filter(user => user.id !== action.payload) }
        case DELETE_USER_CLIENT_FAIL:
            return { ...state, loading: false, error: action.payload }
        default:
            return state
    }
}

export default usersClientReducer
